import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import { languagesHelper as language } from '../../util/languages';
import { normalizeTranslations, localizePageAssetData } from '../../util/cmsPageHelper';

import { ASSET_NAME } from './LandingPage.duck';
import { countListingsByFilters } from '../SearchPage/SearchPage.duck';

import FallbackPage from './FallbackPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const {
    pageAssetsData,
    inProgress,
    error,
    listingsByFilters,
    onCountListingsByFilters,
    pageTranslations,
  } = props;

  const locale = language.get();
  const originalPage = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};

  const rawTranslations = pageTranslations || {};
  const userTranslations = normalizeTranslations(rawTranslations);

  const localizedPage = localizePageAssetData(originalPage, userTranslations, locale);

  return (
    <PageBuilder
      pageAssetsData={localizedPage}
      inProgress={inProgress}
      error={error}
      listingsByFilters={listingsByFilters}
      onCountListingsByFilters={onCountListingsByFilters}
      fallbackPage={<FallbackPage error={error} />}
      topbarFixed
      pageId={ASSET_NAME}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { pageTranslations } = state.EditTranslationsPage || {};
  const { listingsByFilters } = state.SearchPage;

  return { pageAssetsData, inProgress, error, listingsByFilters, pageTranslations };
};

const mapDispatchToProps = dispatch => ({
  onCountListingsByFilters: queryParams => dispatch(countListingsByFilters(queryParams)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LandingPageComponent);

export default LandingPage;
